import { InjectionToken } from '@angular/core';
/**
 * Removes white spaces on a given string param
 *
 * @method      trimAll
 * @argument    str: string
 */
export const trimAll = (str) => {
    if (!str) {
        return '';
    }

    return str.replace(/ /g,'');
};

export type TrimAllProvider = (str: string) => string;
export const TRIM_ALL =
    new InjectionToken('TRIM_ALL', {
        factory: () => trimAll
    });
